import React, {Component} from 'react';
import {Table, Button, Icon, Select, Input} from 'antd';
import {Link} from 'react-router-dom';
import * as moment from 'moment';

const {Option, OptGroup} = Select;
const {Search} = Input;

class Properties extends Component {
    constructor(props) {
        super(props);
        const params = new URL(window.location.href).searchParams;
        const due = params.get('due') || 'all';
        const responsible = params.get('responsible') || 'all';
        const page = params.get('page') || 1;
        const query = params.get('query') || '';

        this.state = {
            pagination: {
                current: +page
            },
            responsible,
            due,
            query
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.loading) return null;

        const {current_page: current = 1, per_page: pageSize = 15, total = 100} = nextProps.meta;
        return {pagination: {...prevState.pagination, current, total, pageSize}};
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            (this.state.pagination.current !== prevState.pagination.current) ||
            (this.state.responsible !== prevState.responsible) ||
            (this.state.due !== prevState.due) ||
            (this.state.query !== prevState.query)
        ){
            const {responsible, due, pagination, query} = this.state;
            const {landlord} = this.props;
            this.props.fetchProperties(landlord, pagination.current, responsible, due, query);
        }
    }
    handleTableChange(pagination) {
        const { history, match: {url}} = this.props;
        const {current} = pagination;
        this.setState({pagination: {...this.state.pagination, current}}, () => {
            const parsed = new URL(window.location.href);
            parsed.searchParams.set('page', current);
            history.push(`${url}${parsed.search}`)
        });
    }
    componentDidMount() {
        const {fetchProperties, landlord} = this.props;
        const params = new URL(window.location.href).searchParams;
        const page = params.get('page') || 1;
        const due = params.get('due') || 'all';
        const responsible = params.get('responsible') || 'all';
        const query = params.get('query') || '';
        return fetchProperties(landlord, page, responsible, due, query);
    }
    onFilterChange(filter) {
        const {history, match: {url}} = this.props;
        return val => {
            this.setState({[filter]: val, pagination: {...this.state.pagination, current: 1}}, () => {
                const parsed = new URL(window.location.href);
                parsed.searchParams.set('page', 1);
                parsed.searchParams.set(filter, val);
                history.push(`${url}${parsed.search}`);
            });
        }
    }
    render() {
        const {match, location: {search}, loading = false, properties, includeHeader, contractors, history} = this.props;
        const {due, responsible, query} = this.state;
        const color = date => {
            let color = '#52c41a';
            if (!date) return color;

            const diff = moment(date, 'YYYY-MM-DD').diff(moment(), 'days');
            if (diff < 0) {
                color = '#f5222d';
            } else if (diff < 60) {
                color = '#faad14'
            }
            return color;
        };

        const columns = [{
            title: 'Property Ref No',
            dataIndex: 'registration_no',
            key: 'registration_no',
            render: (text, record) => (
                <span>
                    <Link to={{
                        pathname: `/provider/properties/${record.id}/edit`,
                        state: {
                            from: search || 'page=1'
                        }
                    }}>{text}</Link>
                </span>
            )
        }, {
            title: 'Occupier',
            dataIndex: 'occupier',
            key: 'occupier',
            render: (text, record) => {
                const {title, first_name, surname} = record;
                return `${title ? title + '.' : ''} ${first_name || ''} ${surname || ''}`;
            }
        }, {
            title: 'Property Number',
            dataIndex: 'house_no',
            key: 'house_no'
        }, {
            title: 'Street/Road',
            dataIndex: 'street',
            key: 'street'
        }, {
            title: 'District',
            dataIndex: 'district',
            key: 'district'
        }, {
            title: 'Town/City',
            dataIndex: 'city',
            key: 'city'
        }, {
            title: 'Postcode',
            dataIndex: 'postcode',
            key: 'postcode'
        }, {
            title: 'Next Safety Certificate Due',
            dataIndex: 'certificate_next_due',
            key: 'certificate_next_due',
            render: (text, record) => {
                const {certificate_next_due} = record;
                const date = certificate_next_due.date;
                return <span style={{color: color(date)}}>{moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')}</span>;
            }
        }, {
            title: 'Next Service Due',
            dataIndex: 'service_next_due',
            key: 'service_next_due',
            render: (text, record) => {
                const {service_next_due} = record;
                const date = service_next_due.date;
                return <span style={{color: color(date)}}>{moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')}</span>;
            }
        }, {
            title: 'Responsible',
            dataIndex: 'responsible',
            key: 'responsible',
            render: (text, record) => {
                const {responsible} = record;
                return responsible ? responsible.business_name : 'DLO'
            }
        }];

        const clearFilter = () => {
            this.setState({
                pagination: {...this.state.pagination, current: 1},
                responsible: 'all',
                due: 'all'
            }, () => {
                const parsed = new URL(window.location.href);
                parsed.searchParams.delete('responsible');
                parsed.searchParams.delete('due');
                history.push(`${match.url}${parsed.search}`)
            });
        };

        return (
            <div>
                {includeHeader ? (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                    }}>
                        <div>
                            <span style={{ marginRight: 10 }}>Filter</span>
                            <Select onChange={this.onFilterChange('due')} value={due} style={{ width: 200, marginRight: 10 }}>
                                <Option value='all'>All</Option>
                                <Option value='in-date'>In Date</Option>
                                <Option value='due'>Due</Option>
                                <Option value='overdue'>Overdue</Option>
                            </Select>
                            <Select onChange={this.onFilterChange('responsible')} value={responsible} style={{ width: 200, marginRight: 10 }}>
                                <Option value='all' key="all">All</Option>
                                <Option value='dlo' key="dlo">DLO</Option>
                                <OptGroup label="Contractors">
                                    {contractors.map(b => (
                                        <Option value={'' + b.id} key={'c' + b.id}>{b.business_name}</Option>
                                    ))}
                                </OptGroup>
                            </Select>
                            <Button style={{marginBottom: 10, marginRight: 10}} type="primary" onClick={clearFilter}>
                                Clear Filter
                            </Button>
                            <Search
                                placeholder="Search"
                                onSearch={this.onFilterChange('query')}
                                style={{ width: 300 }}
                                enterButton
                                defaultValue={query}
                            />
                        </div>
                        <div>
                            <Button style={{marginBottom: 10, marginRight: 10}} type="primary">
                                <Link to={`${match.url}/new`}><Icon type="plus"/> Single Property</Link>
                            </Button>
                            <Button style={{marginBottom: 10}} type="primary">
                                <Link to={`${match.url}/import`}><Icon type="upload"/> Import CSV</Link>
                            </Button>
                        </div>
                    </div>
                ) : null}
                <Table
                    columns={columns}
                    dataSource={properties}
                    loading={loading}
                    pagination={this.state.pagination}
                    rowKey={record => record.id}
                    size="middle"
                    onChange={this.handleTableChange.bind(this)}
                />
            </div>
        );
    }
}

export default Properties;


// WEBPACK FOOTER //
// ./resources/assets/js/components/shared/Properties.js